/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading reviewers…" |
*
* @param {Iconik_Publish_Reviewers_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_loading = /** @type {((inputs?: Iconik_Publish_Reviewers_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Loading reviewers…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Loading reviewers…")
	return /** @type {LocalizedString} */ ("Loading reviewers…")
});